export default __webpack_public_path__ + "static/media/Ordenkaos.92cd9ba1.png";